import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=727aa428&scoped=true&"
import script from "./SliderComponent.vue?vue&type=script&lang=js&"
export * from "./SliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=727aa428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727aa428",
  null
  
)

export default component.exports